// import { useNavigate } from "react-router-dom";
// import { ILogin } from "../../models/Login";
import { VideoView } from "./VideoView";
// import { useEffect } from "react";
// import { ImageShowLike } from "../dashbord/ImageShowLike";
// import MileStoneStapper from "../mileStoneStapper/mileStoneStapper";
// import { DemoMilestone } from "../demoMilestone";
// import { AchieversGridImage } from "../achiversGridImage/AchieversGridImage";

import SatyajitNayak from "../../assets/flags/User_Image_1.jpeg";
import PuneetMudgal from "../../assets/flags/User_Image_2.jpg";
import AdityaRana from "../../assets/flags/User_Image_3.jpg";
import GirijeshBhardwaj from "../../assets/flags/User_Image_4.jpeg";
import PankajYadav from "../../assets/flags/User_Image_5.jpg";
import VishantTomar from "../../assets/flags/User_Image_6.jpeg";
import ShivansuSingh from "../../assets/flags/User_Image_7.jpeg";
import AnchalShrivastav from "../../assets/flags/User_Image_8.jpeg";
import KuldeepSharma from "../../assets/flags/User_Image_9.jpeg";
import SubodhKumar from "../../assets/flags/User_Image_10.jpeg";
import AniketSingh from "../../assets/flags/User_Image_11.jpeg";
import NaveenSingh from "../../assets/flags/User_Image_12.jpeg";
import HarshSingh from "../../assets/flags/User_Image_13.jpeg";
import ArtiSharma from "../../assets/flags/User_Image_14.jpeg";
import SujitKumarDash from "../../assets/flags/User_Image_36.jpeg";
import MichaelSmith from "../../assets/flags/User_Image_18.jpeg";
import AbhishekYadav from "../../assets/flags/User_Image_19.jpeg";
import ShivaniSharma from "../../assets/flags/User_Image_16.jpeg";
import VikasVerm from "../../assets/flags/User_Image_17.jpeg";
import VipinKumar from "../../assets/flags/User_Image_20.jpeg";
import LovelySingh from "../../assets/flags/User_Image_21.jpeg";
//import MalaShah from "../../assets/flags/User_Image_22.jpeg";
import RhoitSingh from "../../assets/flags/User_Image_23.jpeg";
import KhushbooRajput from "../../assets/flags/User_Image_24.jpeg";
import PiyushVarshney from "../../assets/flags/User_Image_25.jpeg";
import PankajUpadhyay from "../../assets/flags/User_Image_26.jpeg";
import SumitPratapSingh from "../../assets/flags/User_Image_27.jpeg";
import RonakGupta from "../../assets/flags/User_Image_28.jpeg";
import MohdIqbalKhan from "../../assets/flags/User_Image_29.jpeg";
import LipsaMohnty from "../../assets/flags/User_Image_30.jpeg";
import ShaikMohasin from "../../assets/flags/User_Image_31.jpeg";
import ShivanshuSingh from "../../assets/flags/User_Image_32.jpeg";
import DeepakSingh from "../../assets/flags/User_Image_33.jpeg";
import ShrastiSingh from "../../assets/flags/User_Image_34.jpeg";
import RaviDubey from "../../assets/flags/User_Image_35.jpeg";
import AnkitaRoul from "../../assets/flags/User_Image_37.jpg";
import BhumikaKatyal from "../../assets/flags/User_Image_38.jpg";
import PrakharShukla from "../../assets/flags/User_Image_39.jpg";
import ShivanshSingh from "../../assets/flags/User_Image_40.jpeg";
import AbhinavKumar from "../../assets/flags/User_Image_41.jpeg";
import AmitKumarPradhan from "../../assets/flags/User_Image_42.jpeg";
import AnandPrajapati from "../../assets/flags/User_Image_43.jpeg";
import TusharKumarSahoo from "../../assets/flags/User_Image_44.jpeg";
import SanskarDauneria from "../../assets/flags/User_Image_45.jpeg";
import Shipra from "../../assets/flags/User_Image_46.jpeg";
import PankajYadav1 from "../../assets/flags/User_Image_47.jpeg";
//import NitinShukla from "../../assets/flags/User_Image_48.jpeg";
//import JanhaviSingh from "../../assets/flags/User_Image_49.jpeg";
import PawanTiwari from "../../assets/flags/User_Image_50.jpeg";
import ShipraYadav from "../../assets/flags/User_Image_51.jpeg";
import InderMohanNegi from "../../assets/flags/User_Image_52.jpeg";
import AnupamSingh from "../../assets/flags/User_Image_53.jpeg";
import AyasJena from "../../assets/flags/User_Image_54.jpeg";
import NitinShukla from "../../assets/flags/User_Image_55.jpeg";
import VibhorSingh from "../../assets/flags/User_Image_56.jpeg";
import MalaShah from "../../assets/flags/User_Image_57.jpeg";
import RohitSingh from "../../assets/flags/User_Image_58.jpeg";
import JanhaviSingh from "../../assets/flags/User_Image_59.jpeg";
import SameekshaSingh from "../../assets/flags/User_Image_60.jpeg";
import RishuUpadhyay from "../../assets/flags/User_Image_61.jpeg";
import JayantKumar from "../../assets/flags/User_Image_62.jpeg";
import MohdFazilRaza from "../../assets/flags/User_Image_63.jpeg";
import NareshKumarJena from "../../assets/flags/User_Image_64.jpeg";
import VanshPratapSingh from "../../assets/flags/User_Image_65.jpeg";
import ShreyaSrivastava from "../../assets/flags/User_Image_66.jpeg";
import AnkitaPorwal from "../../assets/flags/User_Image_67.jpeg";
import ArjunSingh from "../../assets/flags/User_Image_68.jpeg";
import JanviJha from "../../assets/flags/User_Image_69.jpeg";
import TrainerApprovalForm from "../carnivalTraining/trainingDashboard/TrainerApprovalForm";
import { TrainerScheduleApprovalForm } from "../carnivalTraining/trainingDashboard/TrainerScheduleApprovalForm";
import { TodayTrainingDispaly } from "../carnivalTraining/trainingDashboard/TodayTrainingDispaly";
import TrainingTrainerRatingsPage from "../carnivalTraining/trainingDashboard/TrainingTrainerRatingsPage";

const letData: {
    order: number,
    loginID: number,
    name: string,
    image: any
}[] = [
        {
            order: 1,
            loginID: 2588,
            name: "Girijesh Bhardwaj",
            image: GirijeshBhardwaj
        },
        {
            order: 2,
            loginID: 11845,
            name: "Aditya Rana",
            image: AdityaRana
        },
        {
            order: 3,
            loginID: 3836,
            name: "Satyajit Nayak",
            image: SatyajitNayak
        },
        {
            order: 4,
            loginID: 12171,
            name: "Puneet Mudgal",
            image: PuneetMudgal
        },
        {
            order: 5,
            loginID: 12113,
            name: "Pankaj Yadav",
            image: PankajYadav
        },
        {
            order: 6,
            loginID: 5708,
            name: "Visant Tomar",
            image: VishantTomar
        },
        {
            order: 7,
            loginID: 2388,
            name: "Shivansu Singh",
            image: ShivansuSingh
        },
        {
            order: 8,
            loginID: 12145,
            name: "Anchal Srivastava",
            image: AnchalShrivastav
        },
        {
            order: 9,
            loginID: 5866,
            name: "Kuldeep Sharma",
            image: KuldeepSharma
        },
        {
            order: 10,
            loginID: 4166,
            name: "Subodh Kumar",
            image: SubodhKumar
        },
        {
            order: 11,
            loginID: 12379,
            name: "Naveen Singh",
            image: NaveenSingh
        },
        {
            order: 12,
            loginID: 11792,
            name: "Harsh Singh",
            image: HarshSingh
        },
        {
            order: 13,
            loginID: 4470,
            name: "Aniket Singh",
            image: AniketSingh
        },
        {
            order: 14,
            loginID: 1365,
            name: "Arti Sharma",
            image: ArtiSharma
        },
        { order: 15, loginID: 5887, name: "Michael Smith", image: MichaelSmith },
        { order: 16, loginID: 12065, name: "Abhishek Yadav", image: AbhishekYadav },
        { order: 17, loginID: 11673, name: "Shivani Sharma", image: ShivaniSharma },
        { order: 18, loginID: 11855, name: "Vikas Verma", image: VikasVerm },
        { order: 19, loginID: 5840, name: "Vipin Kumar", image: VipinKumar },
        { order: 20, loginID: 11763, name: "Lovely Singh", image: LovelySingh },
        { order: 23, loginID: 3783, name: "Khushboo Rajput", image: KhushbooRajput },
        { order: 24, loginID: 3793, name: "Piyush Varshney", image: PiyushVarshney },
        { order: 25, loginID: 3694, name: "Sumit Pratap Singh", image: SumitPratapSingh },
        { order: 26, loginID: 5611, name: "Pankaj Upadhyay", image: PankajUpadhyay },
        { order: 27, loginID: 4430, name: "Ronak Gupta", image: RonakGupta },
        { order: 28, loginID: 4430, name: "Ronak Gupta", image: RonakGupta },
        { order: 29, loginID: 12038, name: "Mohd Iqbal Khan", image: MohdIqbalKhan },
        { order: 30, loginID: 5628, name: "Lipsa Mohnty", image: LipsaMohnty },
        { order: 31, loginID: 4094, name: "Shaik Mohasin", image: ShaikMohasin },
        { order: 32, loginID: 11753, name: "Deepak Singh", image: DeepakSingh },
        { order: 33, loginID: 9204, name: "Shrasti Singh", image: ShrastiSingh },
        { order: 34, loginID: 2388, name: "Shivanshu Singh", image: ShivanshuSingh },
        { order: 35, loginID: 4298, name: "Ravi Dubey", image: RaviDubey },
        { order: 36, loginID: 3736, name: "Sujit Kumar Dash", image: SujitKumarDash },
        { order: 37, loginID: 4097, name: "Ankita Roul", image: AnkitaRoul },
        { order: 38, loginID: 11958, name: "Bhumika Katyal", image: BhumikaKatyal },
        { order: 39, loginID: 12135, name: "Prakhar Shukla", image: PrakharShukla },
        { order: 40, loginID: 12310, name: "Shivansh Singh", image: ShivanshSingh },
        { order: 41, loginID: 4538, name: "Amit Kumar Pradhan", image: AmitKumarPradhan },
        { order: 42, loginID: 3902, name: "Abhinav Kumar", image: AbhinavKumar },
        { order: 43, loginID: 5779, name: "Anand Prajapati", image: AnandPrajapati },
        { order: 44, loginID: 11875, name: "Tushar Kumar Sahoo", image: TusharKumarSahoo },
        { order: 45, loginID: 5784, name: "Sanskar Dauneria", image: SanskarDauneria },
        { order: 46, loginID: 0, name: "Shipra", image: Shipra },
        { order: 47, loginID: 12113, name: "Pankaj Yadav", image: PankajYadav1 },
        { order: 49, loginID: 2438, name: "Pawan Tiwari", image: PawanTiwari },
        { order: 51, loginID: 330, name: "Shipra Yadav", image: ShipraYadav },
        { order: 52, loginID: 4567, name: "Inder Mohan Negi", image: InderMohanNegi },
        { order: 53, loginID: 11761, name: "Anupam Singh", image: AnupamSingh },
        { order: 54, loginID: 3722, name: "Ayas Jena", image: AyasJena },
        { order: 55, loginID: 11838, name: "Nitin Shukla", image: NitinShukla },
        { order: 56, loginID: 128, name: "VibhorSingh", image: VibhorSingh },
        { order: 57, loginID: 11733, name: "Mala Shah", image: MalaShah },
        { order: 58, loginID: 11750, name: "Rohit Singh", image: RohitSingh },
        { order: 60, loginID: 2585, name: "Janhavi Singh", image: JanhaviSingh },
        { order: 61, loginID: 11957, name: "Sameeksha Singh", image: SameekshaSingh },
        { order: 62, loginID: 4431, name: "Rishu Upadhyay", image: RishuUpadhyay },
        { order: 63, loginID: 12334, name: "Jayant Kumar", image: JayantKumar },
        { order: 64, loginID: 12211, name: "Mohd Fazil Raza", image: MohdFazilRaza },
        { order: 65, loginID: 3735, name: "Naresh Kumar Jena", image: NareshKumarJena },
        { order: 66, loginID: 11935, name: "Vansh Pratap Singh", image: VanshPratapSingh },
        { order: 67, loginID: 4331, name: "Shreya Srivastava", image: ShreyaSrivastava },
        { order: 68, loginID: 3658, name: "Ankita Porwal", image: AnkitaPorwal },
        { order: 69, loginID: 4022, name: "Arjun Singh", image: ArjunSingh },
        { order: 70, loginID: 12312, name: "Janvi Jha", image: JanviJha },
    ];

export const VideoMast = () => {
    // const Navigate = useNavigate();
    // const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    // useEffect(() => {
    //     if (loginObj.user_Type !== 1) {
    //         Navigate("/showPurchase");
    //     }
    // });
    return (
        <div>
            {/* <TrainingTrainerRatingsPage /> */}
            {/* <TodayTrainingDispaly /> */}
            {/* <TrainerApprovalForm /> */}
            {/* <TrainerScheduleApprovalForm /> */}
            <VideoView />
            {/* <MileStoneStapper />
            <AchieversGridImage />
            <DemoMilestone /> */}


            {/* <Mission /> */}
            {/* <div style={{ width: "100%", height: "57vh", display: "block", border: "1px solid #ccc", margin: "0 auto", overflowY: "scroll" }}>
                {letData
                    .sort((a, b) => b.order - a.order)
                    .map((item: any, index: number) => (
                        <div key={index}>
                            <ImageShowLike loginID={item.loginID} image={item.image} />
                        </div>
                    ))}
            </div> */}
        </div>
    );
}